/**
 * lib/titresPages.js — titre de l'onglet pour chaque route du module Bourse d'Idées.
 * Appliqué par components/SuiviPages.js.
 */

export const SUFFIXE_TITRE = 'Innovactive360';
const TITRE_MODULE = "Bourse d'Idées";

const TITRES = {
  "/": "Bourse d'Idées",
  "/projects": "Projets - Bourse d'Idées",
  "/projects/create": "Nouveau projet - Bourse d'Idées",
  "/my-projects": "Mes projets - Bourse d'Idées",
  "/call-for-projects": "Appels à projets",
  "/call-for-projects/create": "Nouvel appel à projets",
  "/my-applications": "Mes candidatures",
  "/financing": "Financements",
  "/favorites": "Favoris - Bourse d'Idées",
  "/matching": "Mise en relation - Bourse d'Idées",
  "/messaging": "Messagerie - Bourse d'Idées",
  "/contacts": "Contacts - Bourse d'Idées",
  "/dashboard": "Tableau de bord - Bourse d'Idées",
  "/profile": "Mon profil - Bourse d'Idées",
  "/users": "Profils - Bourse d'Idées",
  "/subscriptions": "Abonnements - Bourse d'Idées",
  "/payment": "Paiement - Bourse d'Idées",
  "/admin": "Administration - Bourse d'Idées",
  "/super-admin": "Super administration - Bourse d'Idées",
  "/login": "Connexion - Bourse d'Idées",
  "/register": "Inscription - Bourse d'Idées",
};

/** Titre complet de l'onglet pour un chemin (préfixe le plus long), ex. « Appels à projets - Innovactive360 ». */
export function titrePourChemin(chemin) {
  let partie = chemin.replace(/\/+$/, '') || '/';
  for (;;) {
    const titre = TITRES[partie];
    if (titre) return `${titre} - ${SUFFIXE_TITRE}`;
    if (partie === '/') return `${TITRE_MODULE} - ${SUFFIXE_TITRE}`;
    const i = partie.lastIndexOf('/');
    partie = i <= 0 ? '/' : partie.slice(0, i);
  }
}
